<template lang="pug">
.confirmation-info
  .columns
    .column.is-one-third
      .info-pair
        .label Name
        .txt(v-if="patient") {{ getUserFormatted(patient) }}
    .column.is-one-third
      .info-pair
        .label Date
        .txt(v-if="schedule") {{ getDateFromUnixFormatted(schedule.availableAt) }}
    .column.is-one-third
      .info-pair
        .label Time
        .txt(v-if="schedule") {{ getTimeFromUnixFormatted(schedule.availableAt) }} 
  .info-pair
    .label Clinic
    .txt(v-if="clinic") {{ clinic.name }}<br/> {{ clinic.address.address}}<br/> {{ clinic.address.place }}, {{ clinic.address.abbreviation}} {{ clinic.address.zipCode }}<br />{{ getPhoneFormatted(clinic.contact.businessPhone) }}
</template>

<script>
import { defineComponent } from "vue";
import {
  getDateFromUnixFormatted,
  getTimeFromUnixFormatted,
  getUserFormatted,
  getPhoneFormatted,
} from "@/helpers";
import { fetchPatient } from "@/api/patientApi";
import { fetchPatientAppointmentAvailableScheduleById } from "@/api/patientAppointmentApi";
import { fetchClinic } from "@/api/clinicApi";

import { apiStatus, apiStatusComputedFactory } from "@/api";
const { IDLE, PENDING, SUCCESS, ERROR } = apiStatus;

export default defineComponent({
  components: {},

  data() {
    return {
      fetchPatientStatus: IDLE,
      fetchPatientAppointmentAvailableScheduleByIdStatus: IDLE,
      fetchCliniclStatus: IDLE,
      patient: null,
      schedule: null,
      clinic: null,
    };
  },

  computed: {
    ...apiStatusComputedFactory(
      "fetchPatientStatus",
      "fetchPatientAppointmentAvailableScheduleByIdStatus",
      "fetchClinicStatus"
    ),
  },

  methods: {
    getDateFromUnixFormatted,
    getTimeFromUnixFormatted,
    getUserFormatted,
    getPhoneFormatted,
    async fetchPatient() {
      this.fetchPatientStatus = PENDING;
      try {
        const res = await fetchPatient(this.$route.params.idPatient);
        this.patient = res.data.patient;
        this.fetchPatientStatus = SUCCESS;
      } catch (err) {
        this.fetchPatientStatus = ERROR;
        console.error(err);
      }
    },
    async fetchPatientAppointmentAvailableScheduleById() {
      this.fetchPatientAppointmentAvailableScheduleByIdStatus = PENDING;
      try {
        const res = await fetchPatientAppointmentAvailableScheduleById(
          this.$route.params.idSchedule
        );
        this.schedule = res.data.schedule;
        this.fetchPatientAppointmentAvailableScheduleByIdStatus = SUCCESS;
      } catch (err) {
        this.fetchPatientAppointmentAvailableScheduleByIdStatus = ERROR;
        console.error(err);
      }
    },
    async fetchClinic() {
      this.fetchClinicStatus = PENDING;
      try {
        const res = await fetchClinic(this.$route.params.idClinic);
        this.clinic = res.data;
       
        this.fetchClinicStatus = SUCCESS;
      } catch (err) {
        this.fetchClinicStatus = ERROR;
        console.error(err);
      }
    },
  },
  created() {
    if (this.$route.params.idPatient === null) return;
    this.fetchPatient();
    this.fetchPatientAppointmentAvailableScheduleById();
    this.fetchClinic();
  },
});
</script>

<style scoped lang="scss">
.confirmation-info {
  background-color: $primaryBgBlue;
  padding: 37px 37px 17px;
}
</style>
